(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["au-cart-tagalys-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var S = '[data-product-based-widget]';
    var WIDGET = '[data-pbw-loc="scrollable"]';
    var EMPTY = '[data-pbw-loc="empty"]';
    var DRAWER = '#CartDrawer';

    var $drawer, $products;
    var sId = 0,
      cId = 0;
    var lock = false,
      pending = false,
      ready = false,
      debounce = null;

    function $$(sel, root) {
      return (root || document).querySelectorAll(sel);
    }
    function isVisible() {
      return $drawer && ($drawer.classList.contains('drawer--is-open') || $drawer.classList.contains('is-visible'));
    }

    function resetContainer(loc) {
      var el = document.querySelector(loc === 'empty' ? EMPTY : WIDGET);
      if (el) {
        delete el.__auInited;
        el.innerHTML = '';
      }
      return el;
    }

    /* ── Product JSON cache ── */
    var productCache = {};
    function fetchProduct(handle, cb) {
      if (productCache[handle]) {
        cb(productCache[handle]);
        return;
      }
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (p) {
          productCache[handle] = p;
          cb(p);
        })
        .catch(function () {
          cb(null);
        });
    }

    /* ── Helper to resolve option name string from either string or object ── */
    function getOptionName(opt) {
      if (!opt) return '';
      if (typeof opt === 'string') return opt;
      if (typeof opt === 'object' && opt.name) return opt.name;
      return '';
    }

    /* ── Determine CTA label from option name ── */
    function ctaLabel(opt) {
      var optName = getOptionName(opt);
      var n = (optName || '').toLowerCase();
      if (n === 'color' || n === 'colour') return 'Choose Colour';
      if (n === 'size') return 'Choose Size';
      if (n.indexOf('flavo') > -1 || n.indexOf('flavou') > -1 || n.indexOf('flavor') > -1) return 'Choose Flavour';
      return 'Choose Option';
    }

    /* ── Find variant ID matching selected options ── */
    function findVariantId(product, selections) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var k = 0; k < product.options.length; k++) {
          if (selections[k] && v['option' + (k + 1)] !== selections[k]) {
            match = false;
            break;
          }
        }
        if (match) return v.id;
      }
      return product.variants[0].id;
    }

    /* ── Collect unique values for an option index ── */
    function optionValues(product, idx) {
      var seen = {},
        vals = [];
      for (var i = 0; i < product.variants.length; i++) {
        var val = product.variants[i]['option' + (idx + 1)];
        if (val && !seen[val]) {
          seen[val] = true;
          vals.push(val);
        }
      }
      return vals;
    }

    /* ── Build single variant dropdown populated with variant titles ── */
    function buildVariantUI(cardEl, product, handle, ctaBtn) {
      if (!product || !product.variants || product.variants.length <= 1) {
        return null;
      }

      /* Single variant or "Default Title" only → keep standard Add button */
      if (
        product.variants.length === 1 ||
        (product.options.length === 1 && getOptionName(product.options[0]) === 'Title')
      ) {
        return null;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'au-tagalys-variant-area au-tagalys-variant-area--hidden';
      wrapper.setAttribute('data-handle', handle);

      var row = document.createElement('div');
      row.className = 'variant-wrapper variant-wrapper--dropdown js';

      var wrap = document.createElement('div');
      wrap.className = 'variant-input-wrap';

      var sel = document.createElement('select');
      sel.className = 'au-tagalys-variant-select';
      sel.setAttribute('data-option-index', '0');

      // Populate options directly from product.variants
      for (var vi = 0; vi < product.variants.length; vi++) {
        var v = product.variants[vi];
        var optionEl = document.createElement('option');
        optionEl.value = v.id; // Variant ID
        optionEl.textContent = v.title; // Combined title e.g. "Miami Mango / Red Cherry / Strawberry Burst"
        if (vi === 0) optionEl.selected = true;
        sel.appendChild(optionEl);
      }

      wrap.appendChild(sel);
      row.appendChild(wrap);
      wrapper.appendChild(row);

      /* Add to cart button (visible immediately after clicking CTA) */
      var addBtn = document.createElement('button');
      addBtn.className = 'au-tagalys-add-to-cart';
      addBtn.textContent = 'Add';
      addBtn.setAttribute('data-handle', handle);
      addBtn.setAttribute('type', 'button');
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedVid = sel.value || product.variants[0].id;
        addToCart(handle, addBtn, selectedVid);
      });
      wrapper.appendChild(addBtn);

      /* Update Add button state based on selected variant availability */
      function updateAddBtnState() {
        var selectedVid = sel.value;
        var selectedVariant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(selectedVid)) {
            selectedVariant = product.variants[i];
            break;
          }
        }
        if (selectedVariant && selectedVariant.available) {
          addBtn.textContent = 'Add';
          addBtn.disabled = false;
          addBtn.classList.remove('au-tagalys-sold-out');
        } else {
          addBtn.textContent = 'Sold Out';
          addBtn.disabled = true;
          addBtn.classList.add('au-tagalys-sold-out');
        }
      }
      updateAddBtnState();

      /* Update card image and button state on select change */
      sel.addEventListener('change', function (e) {
        if (e) {
          e.stopPropagation();
        }
        var selectedVid = sel.value;
        var selectedVariant = product.variants.find(function (item) {
          return String(item.id) === String(selectedVid);
        });

        if (selectedVariant && selectedVariant.featured_image) {
          var img = cardEl.querySelector('.product-image');
          if (img) {
            img.src = selectedVariant.featured_image.src;
            img.setAttribute('data-src', selectedVariant.featured_image.src);
          }
        }

        updateAddBtnState();
      });

      sel.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      /* Stop click and change events from bubbling out of the variant area to prevent theme reloads */
      wrapper.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      wrapper.addEventListener('change', function (e) {
        e.stopPropagation();
      });

      return wrapper;
    }

    /* ── enhance: add buttons / variant selectors to product cards ── */
    function enhance() {
      var widgets = $$(S);
      for (var w = 0; w < widgets.length; w++) {
        var root = widgets[w];
        var imgs = $$('.product-image[data-src]', root);
        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];
          if (!img.src) img.src = img.getAttribute('data-src');
        }
        var prods = $$('.product', root);
        for (var p = 0; p < prods.length; p++) {
          var el = prods[p];
          /* Skip if already processed */
          if (
            el.querySelector('.au-tagalys-add-to-cart') ||
            el.querySelector('.au-tagalys-choose-btn') ||
            el.querySelector('.au-tagalys-bundle-btn')
          )
            continue;
          var link = el.querySelector('.product-link');
          if (!link) continue;
          var href = link.getAttribute('href');
          if (!href) continue;
          var m = href.match(/\/products\/([^?#]+)/);
          if (!m) continue;
          var handle = m[1];

          /* Step 1: Create "Add" button synchronously (always visible immediately) */
          var btn = document.createElement('button');
          btn.className = 'au-tagalys-add-to-cart';
          btn.textContent = 'Add';
          btn.setAttribute('data-handle', handle);
          btn.setAttribute('type', 'button');
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(this.getAttribute('data-handle'), this);
          });
          el.appendChild(btn);

          /* Step 2: Async upgrade — if product has variants, swap Add for "Choose X" CTA */
          (function (cardEl, addBtn, prodHandle) {
            fetchProduct(prodHandle, function (product) {
              if (!product || !product.variants || !product.variants.length) return;

              /* ── PDP-redirect products: "Build bundle" / "Personalize" ── */
              var pdpLabel = null;
              var tags = product.tags || [];
              for (var ti = 0; ti < tags.length; ti++) {
                if (tags[ti].toLowerCase().trim() === 'biscuits-bundle') {
                  pdpLabel = 'Build bundle';
                  break;
                }
              }
              if (!pdpLabel && product.type && product.type.toLowerCase().trim() === 'personalised') {
                pdpLabel = 'Personalize';
              }
              if (pdpLabel) {
                var bundleBtn = document.createElement('button');
                bundleBtn.className = 'au-tagalys-bundle-btn';
                bundleBtn.textContent = pdpLabel;
                bundleBtn.setAttribute('type', 'button');
                bundleBtn.addEventListener('click', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  window.location.href = '/products/' + prodHandle;
                });
                if (addBtn.parentNode) {
                  addBtn.parentNode.replaceChild(bundleBtn, addBtn);
                }
                return;
              }
              /* Single variant or only default "Title" option → keep the Add button */
              if (product.variants.length <= 1) {
                /* Check if sold out */
                if (!product.variants[0].available) {
                  addBtn.textContent = 'Sold Out';
                  addBtn.disabled = true;
                  addBtn.classList.add('au-tagalys-sold-out');
                }
                return;
              }
              var firstOptName = getOptionName(product.options[0]);
              if (product.options.length === 1 && firstOptName === 'Title') {
                /* Check if sold out */
                if (!product.variants[0].available) {
                  addBtn.textContent = 'Sold Out';
                  addBtn.disabled = true;
                  addBtn.classList.add('au-tagalys-sold-out');
                }
                return;
              }
              /* Multi-variant: check if ALL variants are sold out */
              var allSoldOut = true;
              for (var vi = 0; vi < product.variants.length; vi++) {
                if (product.variants[vi].available) {
                  allSoldOut = false;
                  break;
                }
              }
              if (allSoldOut) {
                addBtn.textContent = 'Sold Out';
                addBtn.disabled = true;
                addBtn.classList.add('au-tagalys-sold-out');
                return;
              }

              /* Multi-variant with available stock → replace Add button with CTA */
              var ctaText = ctaLabel(product.options[0]);
              var ctaBtn = document.createElement('button');
              ctaBtn.className = 'au-tagalys-choose-btn';
              ctaBtn.textContent = ctaText;
              ctaBtn.setAttribute('type', 'button');

              /* Build variant UI */
              var variantUI = buildVariantUI(cardEl, product, prodHandle, ctaBtn);

              /* If buildVariantUI returned null (edge case), keep existing Add button */
              if (!variantUI) return;

              ctaBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                /* Hide CTA button */
                ctaBtn.style.display = 'none';
                /* Reveal dropdowns and Add button */
                variantUI.classList.remove('au-tagalys-variant-area--hidden');
              });

              /* Swap: remove old Add button, insert variantUI and CTA */
              if (addBtn.parentNode) {
                addBtn.parentNode.insertBefore(variantUI, addBtn);
                addBtn.parentNode.replaceChild(ctaBtn, addBtn);
              }
            });
          })(el, btn, handle);
        }
        var btns = $$('button:not([type]), button[type="submit"]', root);
        for (var b = 0; b < btns.length; b++) {
          if (
            !btns[b].classList.contains('au-tagalys-add-to-cart') &&
            !btns[b].classList.contains('au-tagalys-choose-btn') &&
            !btns[b].classList.contains('au-tagalys-bundle-btn')
          )
            btns[b].setAttribute('type', 'button');
        }
      }
    }

    function stagger(id, delays) {
      for (var i = 0; i < delays.length; i++) {
        (function (d) {
          setTimeout(function () {
            if (id === sId) enhance();
          }, d);
        })(delays[i]);
      }
    }

    function refresh() {
      if (!isVisible()) return;
      if (lock) {
        pending = true;
        return;
      }
      lock = true;
      try {
        if (
          typeof TagalysCustomisations !== 'undefined' &&
          typeof TagalysCustomisations.initProductBasedWidget === 'function'
        ) {
          try {
            if (TagalysCustomisations.initProductBasedWidget()) ready = true;
          } catch (e) {
            console.warn('[au-tagalys] init error:', e);
          }
        }
        if (ready) {
          sId++;
          stagger(sId, [0, 150, 400, 800, 1500, 3000]);
        }
      } catch (e) {
        console.warn('[au-tagalys] refresh error:', e);
      } finally {
        lock = false;
        if (pending) {
          pending = false;
          setTimeout(refresh, 50);
        }
      }
    }

    function debouncedRefresh() {
      clearTimeout(debounce);
      debounce = setTimeout(refresh, 250);
    }

    function forceRefreshFromOpen() {
      var loc = $drawer && $drawer.classList.contains('is-empty') ? 'empty' : 'scrollable';
      resetContainer(loc);
      watchParents();
      refresh();
      setTimeout(initViewport, 50);
      stagger(sId, [200, 500, 1000, 2000, 3500, 5000]);
    }

    function watchParents() {
      var parents = $$('#CartDrawer .drawer__scrollable, #CartDrawer .drawer__cart-empty');
      for (var i = 0; i < parents.length; i++) {
        var p = parents[i];
        if (p.__auMon) continue;
        p.__auMon = true;
        new MutationObserver(function () {
          enhance();
        }).observe(p, { childList: true, subtree: true });
      }
    }

    var io = null;
    function initViewport() {
      if (typeof IntersectionObserver === 'undefined') return;
      if (!io) {
        io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                refresh();
                setTimeout(enhance, 300);
                setTimeout(enhance, 800);
                setTimeout(enhance, 1500);
              }
            }
          },
          { root: document.querySelector(DRAWER + ' .drawer__scrollable'), threshold: 0.01 }
        );
      }
      var ws = $$(S);
      for (var w = 0; w < ws.length; w++) {
        if (!ws[w].__auViewportObserved) {
          ws[w].__auViewportObserved = true;
          io.observe(ws[w]);
        }
      }
    }

    function initDragGuard() {
      if (document.__auDG) return;
      document.__auDG = true;
      var sx = 0,
        sy = 0,
        dragged = false;

      function down(x, y) {
        sx = x;
        sy = y;
        dragged = false;
      }
      function move(x, y) {
        if (sx && (Math.abs(x - sx) > 5 || Math.abs(y - sy) > 5)) dragged = true;
      }
      function inWidget(t) {
        return t && t.closest && t.closest(S);
      }

      document.addEventListener(
        'mousedown',
        function (e) {
          if (inWidget(e.target)) down(e.clientX, e.clientY);
        },
        true
      );
      document.addEventListener(
        'mousemove',
        function (e) {
          move(e.clientX, e.clientY);
        },
        true
      );
      document.addEventListener(
        'touchstart',
        function (e) {
          var t = e.touches[0];
          if (t && inWidget(e.target)) down(t.clientX, t.clientY);
        },
        true
      );
      document.addEventListener(
        'touchmove',
        function (e) {
          var t = e.touches[0];
          if (t) move(t.clientX, t.clientY);
        },
        true
      );

      document.addEventListener(
        'click',
        function (e) {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return;
          }

          var t = e.target;
          if (!inWidget(t)) return;

          /* Allow PDP navigation ONLY when clicking on Image or Title (or interacting with controls) */
          var isImage =
            t.closest &&
            t.closest(
              '.product-image, .product-image-container, .grid-product__image-mask, .grid-product__image, .image-wrap, img'
            );
          var isTitle =
            t.closest && t.closest('.product-title, .product-name, .grid-product__title, .grid-product__title--body');
          var isControl =
            t.closest &&
            t.closest(
              'button, select, input, .carousel-btn, .au-tagalys-variant-area, .au-tagalys-add-to-cart, .au-tagalys-choose-btn, .au-tagalys-bundle-btn, .au-tagalys-variant-select'
            );

          if (!isImage && !isTitle && !isControl) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        },
        true
      );

      function resetDrag() {
        sx = 0;
        sy = 0;
        if (dragged) {
          setTimeout(function () {
            dragged = false;
          }, 100);
        }
      }

      document.addEventListener('mouseup', resetDrag, true);
      document.addEventListener('touchend', resetDrag, true);
    }

    var vCache = {};
    function addToCart(handle, btn, explicitVid) {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
        btn.classList.add('au-tagalys-atc--busy');
        btn.classList.remove('au-tagalys-atc--added');
      }
      var revert = function () {
        if (!btn) return;
        btn.textContent = 'Add';
        btn.classList.remove('au-tagalys-atc--busy', 'au-tagalys-atc--added');
      };
      var go = function (vid) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 }),
        })
          .then(function (r) {
            if (r.ok) {
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Added';
                btn.classList.remove('au-tagalys-atc--busy');
                btn.classList.add('au-tagalys-atc--added');
                setTimeout(revert, 2000);
              }
              var scrollable = document.querySelector('#CartDrawer .drawer__scrollable');
              if (scrollable) {
                if (typeof scrollable.scrollTo === 'function') {
                  scrollable.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  scrollable.scrollTop = 0;
                }
              } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { addToCartBtn: btn } }));
            } else {
              console.warn('[au-tagalys] add failed');
              if (btn) btn.disabled = false;
              revert();
            }
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            revert();
          });
      };

      /* If an explicit variant ID was provided (from dropdown), use it directly */
      if (explicitVid) {
        go(explicitVid);
        return;
      }

      /* Fallback: fetch first variant (for single-variant products called without ID) */
      if (vCache[handle]) {
        go(vCache[handle]);
        return;
      }
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (p) {
          if (p.variants && p.variants.length) {
            vCache[handle] = p.variants[0].id;
            go(vCache[handle]);
          } else {
            if (btn) btn.disabled = false;
            revert();
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          revert();
        });
    }

    function initCustomCarouselEngine() {
      if (document.__auCustomSliderEngineBound) return;
      document.__auCustomSliderEngineBound = true;

      function getSliderState(btnOrContainer) {
        var widget =
          btnOrContainer.closest('.products-and-navigation') ||
          btnOrContainer.closest(S) ||
          btnOrContainer.closest('.tagalys-namespace') ||
          btnOrContainer.closest('#CartDrawer');
        if (!widget) return null;

        var container = widget.querySelector('.products.display-carousel');
        if (!container) return null;

        var track = container.firstElementChild || container.children[0];
        if (!track) return null;

        var items = track.children;
        if (!items || !items.length) return null;

        var btns = widget.querySelectorAll('.carousel-btn');
        var prevBtn = btns[0] || null;
        var nextBtn = btns[1] || null;

        var viewportWidth = container.getBoundingClientRect().width || 340;
        if (viewportWidth > 50) {
          var cardW = Math.min(189, Math.max(100, (viewportWidth - 20) / 2));
          container.style.setProperty('--au-card-w', cardW + 'px');
        }

        return {
          widget: widget,
          container: container,
          track: track,
          items: items,
          prevBtn: prevBtn,
          nextBtn: nextBtn,
        };
      }

      function updateButtons(state, targetIndex, maxIndex) {
        if (state.prevBtn) {
          if (targetIndex <= 0) state.prevBtn.classList.add('btn-disabled');
          else state.prevBtn.classList.remove('btn-disabled');
        }
        if (state.nextBtn) {
          if (targetIndex >= maxIndex) state.nextBtn.classList.add('btn-disabled');
          else state.nextBtn.classList.remove('btn-disabled');
        }
      }

      function slideToIndex(state, targetIndex) {
        var totalItems = state.items.length;
        var maxIndex = Math.max(0, totalItems - 2);

        if (targetIndex < 0) targetIndex = 0;
        if (targetIndex > maxIndex) targetIndex = maxIndex;

        var itemWidth = state.items[0].getBoundingClientRect().width || 160;
        var gap = 20;
        var step = itemWidth + gap;

        var targetOffset = targetIndex * step;

        state.track.__auIndex = targetIndex;
        state.track.__auOffset = targetOffset;

        state.track.style.setProperty('transform', 'translate3d(-' + targetOffset + 'px, 0px, 0px)', 'important');
        updateButtons(state, targetIndex, maxIndex);
      }

      /* Stop Tagalys slider click handlers and run custom slide logic */
      document.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest && e.target.closest('.carousel-btn');
          if (!btn) return;

          var state = getSliderState(btn);
          if (!state) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var isPrev =
            !!btn.querySelector('.chevron-icon-prev') || (btn.parentNode && btn === btn.parentNode.firstElementChild);
          var currentIndex = state.track.__auIndex || 0;

          if (isPrev) {
            slideToIndex(state, currentIndex - 1);
          } else {
            slideToIndex(state, currentIndex + 1);
          }
        },
        true
      );

      /* Custom Drag / Swipe Handler (Touch & Mouse) */
      var startX = 0;
      var startY = 0;
      var activeState = null;
      var isDragging = false;
      var dragStartIndex = 0;

      function onDragStart(container, clientX, clientY) {
        var state = getSliderState(container);
        if (!state) return;

        activeState = state;
        startX = clientX;
        startY = clientY;
        dragStartIndex = state.track.__auIndex || 0;
        isDragging = true;
        state.track.style.setProperty('transition', 'none', 'important');
      }

      function onDragMove(clientX, clientY) {
        if (!isDragging || !activeState) return;
        var deltaX = startX - clientX;
        var deltaY = startY ? startY - clientY : 0;

        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaX) < 10) return;

        var itemWidth = activeState.items[0].getBoundingClientRect().width || 160;
        var step = itemWidth + 20;
        var totalItems = activeState.items.length;
        var maxIndex = Math.max(0, totalItems - 2);
        var maxOffset = maxIndex * step;

        var baseOffset = dragStartIndex * step;
        var currentDragOffset = baseOffset + deltaX;

        if (currentDragOffset < 0) currentDragOffset = currentDragOffset * 0.3;
        if (currentDragOffset > maxOffset) currentDragOffset = maxOffset + (currentDragOffset - maxOffset) * 0.3;

        activeState.track.style.setProperty(
          'transform',
          'translate3d(-' + currentDragOffset + 'px, 0px, 0px)',
          'important'
        );
      }

      function onDragEnd(clientX) {
        if (!isDragging || !activeState) return;
        isDragging = false;

        activeState.track.style.setProperty('transition', 'transform 300ms cubic-bezier(0.25, 1, 0.5, 1)', 'important');

        var deltaX = startX - clientX;
        var itemWidth = activeState.items[0].getBoundingClientRect().width || 160;
        var step = itemWidth + 20;

        var targetIndex = dragStartIndex;
        var threshold = 35; // minimum drag distance in px to step forward/backward

        if (deltaX > threshold) {
          var steps = Math.max(1, Math.round(deltaX / step));
          targetIndex = dragStartIndex + steps;
        } else if (deltaX < -threshold) {
          var steps = Math.max(1, Math.round(-deltaX / step));
          targetIndex = dragStartIndex - steps;
        }

        slideToIndex(activeState, targetIndex);
        activeState = null;
      }

      /* Touch Listeners */
      document.addEventListener(
        'touchstart',
        function (e) {
          var container = e.target.closest && e.target.closest('#CartDrawer .products.display-carousel');
          if (container && e.touches && e.touches[0]) {
            onDragStart(container, e.touches[0].clientX, e.touches[0].clientY);
          }
        },
        { passive: true }
      );

      document.addEventListener(
        'touchmove',
        function (e) {
          if (isDragging && e.touches && e.touches[0]) {
            onDragMove(e.touches[0].clientX, e.touches[0].clientY);
          }
        },
        { passive: true }
      );

      document.addEventListener(
        'touchend',
        function (e) {
          if (isDragging && e.changedTouches && e.changedTouches[0]) {
            onDragEnd(e.changedTouches[0].clientX);
          }
        },
        { passive: true }
      );

      /* Mouse Drag Listeners */
      document.addEventListener('mousedown', function (e) {
        /* Don't drag when clicking on interactive elements */
        var tag = e.target.tagName;
        if (tag === 'SELECT' || tag === 'INPUT' || tag === 'BUTTON' || tag === 'TEXTAREA' || tag === 'OPTION') return;
        if (e.target.closest && e.target.closest('select, input, button, textarea, .au-tagalys-variant-area')) return;
        var container = e.target.closest && e.target.closest('#CartDrawer .products.display-carousel');
        if (!container) return;
        e.preventDefault(); /* prevent native image drag-and-drop */
        onDragStart(container, e.clientX, e.clientY);
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        /* Safety: if mouse button was released outside window or event was lost */
        if (e.buttons === 0) {
          onDragEnd(e.clientX);
          return;
        }
        onDragMove(e.clientX, e.clientY);
      });

      document.addEventListener('mouseup', function (e) {
        if (isDragging) onDragEnd(e.clientX);
      });

      /* Safety: reset drag if window loses focus */
      window.addEventListener('blur', function () {
        if (isDragging && activeState) {
          isDragging = false;
          activeState.track.style.setProperty(
            'transition',
            'transform 300ms cubic-bezier(0.25, 1, 0.5, 1)',
            'important'
          );
          slideToIndex(activeState, dragStartIndex);
          activeState = null;
        }
      });
    }

    if (window.__auTagalysBooted) return;
    window.__auTagalysBooted = true;

    $drawer = document.querySelector(DRAWER);
    $products = $drawer && document.querySelector(DRAWER + ' [data-products]');

    watchParents();
    initDragGuard();
    initCustomCarouselEngine();

    if (typeof onTagalysReady === 'function') {
      onTagalysReady(function () {
        ready = true;
        refresh();
      });
    }

    if ($products) {
      new MutationObserver(debouncedRefresh).observe($products, { childList: true });
    }

    if ($drawer) {
      var lastEmpty = $drawer.classList.contains('is-empty');
      new MutationObserver(function () {
        var isEmpty = $drawer.classList.contains('is-empty');
        if (isEmpty === lastEmpty) return;
        lastEmpty = isEmpty;

        resetContainer(isEmpty ? 'empty' : 'scrollable');

        cId++;
        var id = cId;
        var delays = [80, 400, 800, 1500, 2500];
        for (var i = 0; i < delays.length; i++) {
          (function (d) {
            setTimeout(function () {
              if (id === cId) refresh();
            }, d);
          })(delays[i]);
        }
      }).observe($drawer, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('drawerOpen.CartDrawer', forceRefreshFromOpen);

    if (!window.__auTagalysPD) {
      window.__auTagalysPD = true;
      var tries = 0;
      var poll = setInterval(function () {
        if (
          typeof TagalysCustomisations !== 'undefined' &&
          typeof TagalysCustomisations.initProductBasedWidget === 'function'
        ) {
          try {
            refresh();
          } catch (_) {}
          tries++;
        }
        if (tries > 50 || (ready && tries > 3)) clearInterval(poll);
      }, 500);
      setTimeout(function () {
        clearInterval(poll);
      }, 25000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
